// src/pages/unauthorized/index.ts

// @jsx createElement
// @jsxFrag createFragment
import {
  createElement,
  createFragment,
  showFullscreenMessage,
} from "@mitosis/frontend-base";
import {links} from "../../../constants.ts";

document.addEventListener("DOMContentLoaded", async () => {
  try {
    showFullscreenMessage(
      <>
        <h1>Nie jesteś zalogowany</h1>
        <a href={links.login()}>
            Przejdź do strony logowania
        </a>
      </>,
    );
  } catch (error) {
    console.error("Failed to initialize page:", error);
  }
});
